import { Box } from '@mui/material';

import NodesGraph from './NodesGraph/NodesGraph';
import ShelfAndPartMap from './ShelfAndPartMap/ShelfAndPartMap';

const WarehouseGeoGraphMap = props => {
  const {
    areaGuid,
    geoMapLoading,
    graphLoading,
    geoMapData,
    graphData,
    setTreeData,
    setSelectedNodeGuid,
    isViewerModalOpen,
    onClickPart,
    closeViewerModal,
    arrangedRows,
    arrangedRowsLoading,
  } = props;

  return (
    <Box
      sx={{
        'width': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'flex-start',
        'gap': 2,
        '@media (max-width: 1200px)': {
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          'width': '400px',
          'height': 'calc(100vh - 135px)',
          'overflow': 'auto',
          'direction': 'ltr',
          '@media (max-width: 1200px)': {
            width: '100%',
            height: 'auto',
          },
        }}
      >
        <NodesGraph
          loading={graphLoading}
          treeData={graphData}
          setTreeData={setTreeData}
          setSelectedNode={setSelectedNodeGuid}
        />
      </Box>
      <Box
        sx={{
          'width': 'calc(100vw - 600px)',
          'height': 'calc(100vh - 135px)',
          'overflow': 'auto',
          'direction': 'rtl',
          'px': 2,
          '@media (max-width: 1200px)': {
            width: '100%',
            height: 'auto',
          },
        }}
      >
        <ShelfAndPartMap
          loading={geoMapLoading}
          shelfsData={geoMapData}
          areaGuid={areaGuid}
          onClickPart={onClickPart}
          isViewerModalOpen={isViewerModalOpen}
          closeViewerModal={closeViewerModal}
          arrangedRows={arrangedRows}
          arrangedRowsLoading={arrangedRowsLoading}
        />
      </Box>
    </Box>
  );
};

export default WarehouseGeoGraphMap;
